import { render } from "./CatalogHead.vue?vue&type=template&id=2d5d215c&scoped=true"
import script from "./CatalogHead.vue?vue&type=script&lang=js"
export * from "./CatalogHead.vue?vue&type=script&lang=js"

import "./CatalogHead.vue?vue&type=style&index=0&id=2d5d215c&scoped=true&lang=scss"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2d5d215c"]])

export default __exports__